<template>
  <DialogDefault
    :title="title"
    :icon-header="iconHeader"
    :close-click-outside="closeClickOutside"
    :label="label"
    :close-timer="closeTimer"
  >
    <DialogUiConfirm
      v-if="buttonConfirm"
      :cancel="false"
      :button-confirm="buttonConfirm"
      @confirm="handleConfirm"
    />
  </DialogDefault>
</template>
<script lang="ts" setup>
interface Props {
  iconHeader?: string;
  title?: string;
  label: string;
  closeTimer?: number;
  closeClickOutside?: boolean;
  buttonConfirm?: string;
}

const emit = defineEmits(["close"]);

defineProps({
  iconHeader: null,
  title: { default: 'Nomad +' },
  label: { default: 'Une erreur est survenue, réessayez un peu plus tard.' },
  closeTimer: { default: 4000 },
  closeClickOutside: { type: Boolean, default: true },
  buttonConfirm: null
});

const dialog = useDialogStore();

const handleConfirm = () => {
  dialog.close();
  emit('close');
};
</script>
